import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { saveAs } from 'file-saver';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { LabelField } from './DocumentAdmin.styles';
import '../../DataTableDemo.css';
import { ProgressSpinner } from 'primereact/progressspinner';
import "../../utils/tooltip.css"
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './DocumentAdmin.css'
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';

const DocumentAdmin = () => {
    // declarar constantes

    const [code, setCode] = useState("")
    const [description, setDescription] = useState("")
    const [extension, setExtension] = useState("")
    const [status, setStatus] = useState("")
    const [docId, setDocId] = useState("")

    const [extensionList, setExtensionList] = useState([])
    const [statusList, setStatusList] = useState([])

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false)
    const [loading3, setLoading3] = useState(false)
    const [loadingExport, setLoadingExport] = useState(false)
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpen_, setIsOpen_] = React.useState(false);
    const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
    const [loadPage, setLoadPage] = useState(false)

    const headers = { authorization: localStorage.getItem('token') }
    const [products, setProducts] = useState([]);
    const [exportContent, setExportContent] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(5);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const toast = useRef(null);

    // funcion para obtener los empleados
    useEffect(() => {
        const getLists = async () => {
            await apis.getDocumentTypeList(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let data = res.data;
                setExtensionList(data.EXTENSION_ARCHIVOS)
                setStatusList(data.LOV_STATUS)
                setLoadPage(true)
            })
        }
        getLists()
    }, []);

    useEffect(() => {
        setTabla()
    }, [])

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        limpiar()
        setIsOpen(false);
    };

    const showModal_ = () => {
        setIsOpen_(true);
    };

    const hideModal_ = () => {
        limpiar()
        setIsOpen_(false);
    };

    const showModalEliminar = () => {
        setIsOpenEliminar(true);
    };

    const hideModalEliminar = () => {
        limpiar()
        setIsOpenEliminar(false);
    };

    const footer = (
        <div>
            <Button label="Cancelar" onClick={() => { setLoading(false); hideModal() }} />
            <Button label="Guardar" loading={loading} onClick={() => { setLoading(true); postDocType() }} />
        </div>
    );

    const header = (
        <div>
            <h3>Crear documento</h3>
        </div>
    )

    const footer_ = (
        <div>
            <Button label="Cancelar" onClick={() => { setLoading2(false); limpiar(); hideModal_() }} />
            <Button label="Guardar" loading={loading2} onClick={() => { setLoading2(true); putDocType() }} />
        </div>
    );

    const header_ = (
        <div>
            <h3>Editar documento</h3>
        </div>
    )

    const footerEliminar = (
        <div>
            <Button label="Cancelar" onClick={() => { setLoading3(false); limpiar(); hideModalEliminar() }} />
            <Button label="Eliminar" loading={loading3} onClick={() => { setLoading3(true); deleteDocType() }} />
        </div>
    );

    const headerEliminar = (
        <div>
            <h3>¿Desea eliminar el documento?</h3>
        </div>
    )

    //Evento para cambiar de pagina
    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }
    //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
    const template2 = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    };

    //Boton Agregar Persona izquierda de la tabla
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm "
                    tooltipOptions={{ position: 'top' }} onClick={() => showModal()}
                />
            </React.Fragment>
        )
    }

    //Boton liquidar Nómina en la parte derecha de la tabla
    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Exportar" icon="pi pi-file-excel" className="p-button-success mr-2 p-button-sm " loading={loadingExport} onClick={() => { setLoadingExport(true); exportExcel() }} />
            </React.Fragment>
        )
    }

    //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
    const actionBodyTemplate = (rowData) => {
        return (
            <div className='flex flex-row'>
                <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => { initializeData(rowData); showModal_() }} />
                <Button icon="pi pi-trash" className="p-button-danger mr-2 p-button-sm text-xs" onClick={() => { setDocId(rowData.DETAIL_ID); showModalEliminar() }} />
            </div>
        )
    }

    //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search"> </InputIcon>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm"
                        style={{
                            width: "100%"
                        }}
                    />
                </IconField>
            </div>
        )
    }

    const showConfirm = () => {
        /* Función encargada de mostrarle al usuario un mesaje de confirmación de la realización del proceso*/
        toast.current.show({
            severity: 'info', sticky: true, content: (
                <div className="flex flex-column" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i >
                            <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100	)" animationDuration=".5s" />
                        </i>
                        <p>Cargando información...</p>
                    </div>
                </div>
            )
        });
    }

    //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    //Limpiar e inicializar los filtros
    const clearFilter1 = () => {
        initFilters1();
    }

    //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
    const header1 = renderHeader1();

    //Limpiar filtros de la tabla
    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'DETAIL_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CODE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'DESCRIPTION': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'FATHER': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue1('');
    }

    //Nombre de las opciciones para los filtros
    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];

    async function setTabla() {
        try {
            await apis.getDocumentType(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let data = res.data.TIPOS_ARCHIVO
                let export_ = []
                data.forEach(row => {
                    export_.push({
                        Id: row.DETAIL_ID, 'Código del documento': row.CODE, 'Nombre documento': row.DESCRIPTION,
                        'Extensión documento': row.FATHER, 'Estado': row.STATUS
                    })
                })
                setExportContent(export_)
                setProducts(data)
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    async function postDocType() {
        console.log(extension)
        const _client = localStorage.getItem("client")
        const _entity = localStorage.getItem("entity")
        const _code = code
        const _description = description
        const _extension = extension
        const _status = status

        const payload = {
            CLIENT: _client,
            ENTITY: _entity,
            CODE: _code,
            DESCRIPTION: _description,
            FATHER: _extension,
            STATUS: _status
        }

        try {
            await apis.postDocumentType(payload, headers).then(res => {
                setLoading(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Documento agregado exitosamente' });
            })
            setTabla()
            hideModal()
            limpiar()
        }
        catch (err) {
            setLoading(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function putDocType() {
        const _client = localStorage.getItem("client")
        const _entity = localStorage.getItem("entity")
        const _code = code
        const _description = description
        const _extension = extension
        const _status = status
        const _docId = docId

        const payload = {
            DETAIL_ID: _docId,
            CLIENT: _client,
            ENTITY: _entity,
            CODE: _code,
            DESCRIPTION: _description,
            FATHER: _extension,
            STATUS: _status
        }

        try {
            await apis.putDocumentType(payload, headers).then(res => {
                setLoading2(false)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Documento actualizado exitosamente' });
            })
            setTabla()
            hideModal_()
            limpiar()
        }
        catch (err) {
            setLoading2(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function deleteDocType() {
        const _cliente = localStorage.getItem("client")
        const _entity = localStorage.getItem("entity")
        const _docId = docId

        try {
            await apis.delDocumentType(_entity, _cliente, _docId, headers).then(res => {
                setLoading3(false)
                toast.current.show({ severity: 'info', summary: 'Info', detail: 'Documento eliminado exitosamente' });
            })
            setTabla()
            limpiar()
            hideModalEliminar()
        }
        catch (err) {
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const exportExcel = () => {
        try {
            excelExport(exportContent, 'Documentos');
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Exportado con éxito" });
        }
        catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: "Error al exportar el archivo" });
        }
        finally {
            setLoadingExport(false);
        }
    }

    async function initializeData(rowData) {
        setCode(rowData.CODE)
        setDescription(rowData.DESCRIPTION)
        setDocId(rowData.DETAIL_ID)
        setExtension(rowData.FATHER)
        setStatus(rowData.STATUS)
    }

    async function limpiar() {
        setCode("")
        setDescription("")
        setDocId("")
        setExtension("")
        setStatus("")
    }


    // Return que entrega la pantalla
    return (
        <div className='mt-2'>
            <Dialog header={header} footer={footer} visible={isOpen}
                position="top" style={{ width: "22rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div>
                    <LabelField htmlFor="label2">Código</LabelField>
                    <InputText
                        style={{ width: "18rem" }}
                        id="label2"
                        type="text"
                        value={code}
                        autoFocus
                        onChange={(e) => setCode(e.target.value)} />
                </div>
                <div>
                    <LabelField htmlFor="label2">Nombre</LabelField>
                    <InputText
                        style={{ width: "18rem" }}
                        id="label2"
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)} />
                </div>
                <div>
                    <LabelField htmlFor="label">Extensión</LabelField>
                    <Dropdown style={{ width: "18rem" }} value={extension} optionValue='code'
                        filter showClear filterBy="description" emptyMessage={"No hay extensiones disponibles"}
                        options={extensionList} placeholder={extension ? extension.description : "Seleccione la extensión"}
                        onChange={(e) => {
                            setExtension(e.value)
                        }}
                        optionLabel='description' className='mb-2'
                    />
                </div>
                <div>
                    <LabelField htmlFor="label">Estado</LabelField>
                    <Dropdown style={{ width: "18rem" }} value={status} optionValue='code'
                        filter showClear filterBy="description" emptyMessage={"No hay estados disponibles"}
                        options={statusList} placeholder={status ? status.description : "Seleccione el estado"}
                        onChange={(e) => {
                            setStatus(e.value)
                        }}
                        optionLabel='description' className='mb-2'
                    />
                </div>
            </Dialog>
            <Dialog header={header_} footer={footer_} visible={isOpen_}
                position="top" style={{ width: "22rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
                <div>
                    <LabelField htmlFor="label2">Código</LabelField>
                    <InputText
                        style={{ width: "18rem" }}
                        id="label2"
                        type="text"
                        value={code}
                        autoFocus
                        onChange={(e) => setCode(e.target.value)} />
                </div>
                <div>
                    <LabelField htmlFor="label2">Nombre</LabelField>
                    <InputText
                        style={{ width: "18rem" }}
                        id="label2"
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)} />
                </div>
                <div>
                    <LabelField htmlFor="label">Extensión</LabelField>
                    <Dropdown style={{ width: "18rem" }} value={extension}
                        filter showClear filterBy="description" emptyMessage={"No hay extensiones disponibles"}
                        options={extensionList} placeholder={"Seleccione la extensión"} optionValue='code'
                        onChange={(e) => {
                            setExtension(e.value)
                        }}
                        optionLabel='description' className='mb-2'
                    />
                </div>
                <div>
                    <LabelField htmlFor="label">Estado</LabelField>
                    <Dropdown style={{ width: "18rem" }} value={status}
                        filter showClear filterBy="description" emptyMessage={"No hay estados disponibles"}
                        options={statusList} placeholder={"Seleccione el estado"} optionValue='code'
                        onChange={(e) => {
                            setStatus(e.value)
                        }}
                        optionLabel='description' className='mb-2'
                    />
                </div>
            </Dialog>
            <Dialog header={headerEliminar} footer={footerEliminar} visible={isOpenEliminar}
                position="top" style={{ width: "22rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
            </Dialog>
            <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
                <Toast ref={toast} />

                <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
                    <span className="text-900">Administración de documentos</span>
                    {/* <Video header="Instructivo saldos iniciales" url={localStorage.getItem('INITIALBALANCE_VIDEO')} /> */}
                </div>

                <div className="card mt-4">
                    <SkeletonTable load={loadPage}>
                        <Toolbar start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>
                        <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
                            dataKey="DETAIL_ID" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                            size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['DETAIL_ID', 'CODE', 'DESCRIPTION', 'FATHER', 'STATUS']}
                            header={header1} >
                            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
                            <Column field="DETAIL_ID" header="Id" showFilterOperator={false} filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por id" sortable></Column>
                            <Column field="CODE" header="Código del documento" showFilterOperator={false} filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por código" sortable></Column>
                            <Column field="DESCRIPTION" header="Nombre documento" showFilterOperator={false} filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por nombre" sortable></Column>
                            <Column field="FATHER" header="Extensión documento" showFilterOperator={false} filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por extensión" sortable></Column>
                            <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filterPlaceholder="Buscar por estado" sortable></Column>
                            <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', width: "6rem" }} body={actionBodyTemplate} />
                        </DataTable>
                    </SkeletonTable>
                </div>

            </div>

        </div >
    );
}

export default DocumentAdmin